import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import EmpadronamientoService from "../../services/EmpadronamientoService";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS, EMPADRONAMIENTO_SOLICITUDES_ESTADOS, EMPADRONAMIENTO_TIPOS_NOTAS, TAMANO_IMAGENES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";
import { validarSoloUnPermiso } from "../../helpers/permisos";
import { EMPADRONAMIENTO_MENU_PERMISOS, MEDICACION_MENU_PERMISOS } from "../../utils/permisos";

const baseUrl = process.env.REACT_APP_API_URL;

export const setActiveStep = (step) => {
  return { type: types.empadronamientoSetStep, payload: step };
};

export const setAfiliadoSeleccionado = (afiliado) => {
  return {
    type: types.empadronamientoSetAfiliadoSeleccionado,
    payload: afiliado,
  };
};

export const cleanAfiliadoSeleccionado = () => {
  return { type: types.empadronamientoCleanAfiliadoSeleccionado };
};

export const setSolicitud = (solicitud) => {
  return {
    type: types.empadronamientoSetSolicitudSeleccionada,
    payload: solicitud
  };
};

export const cleanSolicitudSeleccionada = () => {
  return {
    type: types.empadronamientoCleanSolicitudSeleccionada
  };
};

export const setMedicamentos = (solicitud) => {
  return {
    type: types.empadronamientoSetSolicitudSeleccionadaMedicamentos,
    payload: solicitud.medicamentos,
  };
};

export const setDiagnosticos = (solicitud) => {
  return {
    type: types.empadronamientoSetSolicitudSeleccionadaDiagnosticos,
    payload: solicitud.diagnosticos,
  };
};

export const setEstadoSolicitudes = (estado) => {
  return {
    type: types.empadronamientoUpdateEstadoSolicitudes,
    payload: estado,
  };
};

export const setEstadoMedicacionConsulta = (estado) => {
  return {
    type: types.empadronamientoUpdateEstadoMedicacionConsulta,
    payload: estado,
  };
};

export const setEstadoMedicacion = (estado) => {
  return {
    type: types.empadronamientoUpdateEstadoMedicacion,
    payload: estado
  };
};

export const setEstadoSolicitudesConsulta = (estado) => {
  return {
    type: types.empadronamientoUpdateEstadoSolicitudesConsulta,
    payload: estado,
  };
};


export const setShowForm = (boolean) => {
  return {
    type: types.empadronamientoSetShowForm,
    payload: boolean,
  };
};

export const clearReducer = () => {
  return { type: types.empadronamientoClearReducer };
};

export const cleanSolicitudes = () => ({ type: types.empadronamientoCleanSolicitudes });

export const setIdTipoEmpadronamiento = (idEmpadronamiento) => {
  return {
    type: types.empadronamientoSetTipoEmpadronamiento,
    payload: idEmpadronamiento,
  };
};

export const setearValorEnMedicamento = (idMedicamento, key, value) => {
  return async (dispatch, getState) => {
    const { medicamentos } = getState().empadronamiento;
    const medicamentosAux = [...medicamentos];
    const index = medicamentosAux.findIndex((p) => p.idMedicamento === idMedicamento);
    if (index >= 0) {
      medicamentosAux[index][key] = value;
      console.log("Encontro el valor y setea", value);
      dispatch({
        type: types.empadronamientoSetMedicamentos,
        payload: medicamentosAux,
      });
    }
  };
};
export const setearValorEnMedicamentoPorIdItem = (idItem, key, value) => {
  return async (dispatch, getState) => {
    const { medicamentos } = getState().empadronamiento;
    const medicamentosAux = [...medicamentos];
    const index = medicamentosAux.findIndex((p) => p.idItem === idItem);
    if (index >= 0) {
      console.log("medicamentosAux[index][key]", medicamentosAux[index][key]);
      medicamentosAux[index][key] = value;
      dispatch({
        type: types.empadronamientoSetMedicamentos,
        payload: medicamentosAux,
      });
    }
  };
};

export const deleteMedicamento = (id) => {
  return async (dispatch, getState) => {
    const { medicamentos } = getState().empadronamiento;
    const medicamentosAux = medicamentos.filter(
      (medicamento) => medicamento.idMedicamento !== id
    );
    dispatch({ type: types.empadronamientoSetMedicamentos, payload: medicamentosAux });
  };
};

export const updateSolicitud = (key, value) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().empadronamiento;
    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada };
      solicitudAux[key] = value;
      dispatch({
        type: types.empadronamientoUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const getTiposEmpadronamiento = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getTiposEmpadronamiento();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetTiposEmpadronamientosSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetTiposEmpadronamientosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de empadronamiento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposEmpadronamientoSegunEmpadronamientosActivos = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getTiposEmpadronamientoSegunEmpadronamientos(idAfiliado);
      const body = await result.json();
      
      if (result.ok) {
        if (body.length > 0) {
          dispatch({
            type: types.empadronamientoGetTiposEmpadronamientosSuccess,
            payload: body,
          });
        } else {
          dispatch(startAlerta("El Afiliado no posee ningun Empadronamiento Activo", "error"))
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetTiposEmpadronamientosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de empadronamiento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getEmpadronamientoHistorialPrevio = (idAfiliado) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await EmpadronamientoService.getEmpadronamientosHistorialPrevio(
        idAfiliado
      );
      const body = await result.json();

      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetSolicitudesHistorialSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesHistorialError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los empadronamientos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMigracionHistorialPrevio = (idAfiliado) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await EmpadronamientoService.getMigracionHistorialPrevio(
        idAfiliado
      );
      const body = await result.json();

      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetSolicitudesHistorialMigraSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesHistorialMigraError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los empadronamientos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMedicacionHistorialPrevio = (idAfiliado) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await EmpadronamientoService.getMedicacionHistorialPrevio(
        idAfiliado
      );
      const body = await result.json();

      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetSolicitudesHistorialMedSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesHistorialMedError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los empadronamientos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMedicamentosPermitidosDeEmpadronamiento = (idSolicitudEmp) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await EmpadronamientoService.getMedicamentosDeEmpadronamientoOriginal(
        idSolicitudEmp
      );
      const body = await result.json();

      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetMedicamentosEmpSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetMedicamentosEmpError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los medicamentos del Empadronamiento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMedicacionEmpadronamientosActivosHistorialPrevio = (idAfiliado) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await EmpadronamientoService.getMedicacionEmpadronamientosActivosHistorialPrevio(
        idAfiliado
      );
      const body = await result.json();

      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetSolicitudesActivasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesActivasError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los empadronamientos activos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMedicacionBandeja = (
  idAfiliado,
  idSolicitud,
  idTipoEmpadronamiento,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  esAuditor,
  esAuditorEsp,
  esAuditorDisca,
  esSoloInicio = false
) => {

  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getMedicacionBandeja(
        idAfiliado,
        idSolicitud,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca,
        esSoloInicio
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesBandeja = (
  idAfiliado,
  idTipoEmpadronamiento,
  fechaDesde,
  fechaHasta,
  idSolicitud,
  idEstadoSolicitud,
  esAuditor,
  esAuditorEsp,
  esAuditorDisca,
  esConsulta
) => {

  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const result = await EmpadronamientoService.getSolicitudesBandeja(
        idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        idSolicitud,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca,
        esConsulta
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getContadoresMedicacionBandeja = (
  idAfiliado,
  idSolicitud,
  idTipoEmpadronamiento,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  esAuditor,
  esAuditorEsp,
  esAuditorDisca,
  esSoloInicio = false) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getContadoresMedicacionBandeja(idAfiliado,
        idSolicitud,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca,
        esSoloInicio);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetContadoresSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetContadoresSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los contadores de las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getContadoresEmpadronamientosBandeja = (
  idAfiliado,
  idTipoEmpadronamiento,
  fechaDesde,
  fechaHasta,
  idSolicitud,
  idEstadoSolicitud,
  esAuditor,
  esAuditorEsp,
  esAuditorDisca) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getContadoresEmpadronamientosBandeja(idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        idSolicitud,
        idEstadoSolicitud,
        esAuditor,
        esAuditorEsp,
        esAuditorDisca);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetContadoresSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetContadoresSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los contadores de las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const liberarSolicitudTomada = (
  data,
  setearSolicitud
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.liberarSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitud("idUsuarioTomada", body.idUsuarioTomada));
        dispatch(
          startAlerta(
            "Solicitud liberada con éxito",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const setearSolicitudTomada = (
  data,
  setearSolicitud,
  setRedirect = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.tomarSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitud("idUsuarioTomada", body.idUsuarioTomada));
        setearSolicitud && setearSolicitud(data);
        setRedirect && setRedirect(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const liberarMedicacionTomada = (
  data,
  setearSolicitud
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.liberarSolicitudMedicacion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitud("idUsuarioTomada", body.idUsuarioTomada));
        dispatch(
          startAlerta(
            "Solicitud liberada con éxito",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const setearMedicacionTomada = (
  data,
  setearSolicitud
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.tomarSolicitudMedicacion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitud("idUsuarioTomada", body.idUsuarioTomada));
        setearSolicitud && setearSolicitud(data);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postSolicitud = (
  data,
  setShowForm = null,
  getSolicitudesAuditoria = null,
  createMode,
  setActiveStep = null,
  step = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = createMode
        ? await EmpadronamientoService.postSolicitud(data)
        : await EmpadronamientoService.putSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            createMode
              ? "Solicitud creada correctamente"
              : "Solicitud actualizada correctamente",
            "success",
            "Comando Exitoso"
          )
        );

        if (createMode && result.ok) {
          dispatch(updateSolicitud("idSolicitud", body.idSolicitud));
          dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
          dispatch(updateSolicitud("tipoEmpadronamiento", body.tipoEmpadronamiento));
          dispatch(updateSolicitud("medicamentos", []));
          dispatch(updateSolicitud("diagnosticos", []));
        } else if (data.editandoDiagnosticos && result.ok) {
          dispatch(updateSolicitud("diagnosticos", body.diagnosticos));
        }
        if (setShowForm) dispatch(setShowForm(false));
        if (setActiveStep) dispatch(setActiveStep(step));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar receta"
          : "Error al crear la receta",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postSolicitudMedicacion = (
  data,
  setShowForm = null,
  createMode,
  setActiveStep = null,
  step = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = createMode
        ? await EmpadronamientoService.postSolicitudMedicacion(data)
        : await EmpadronamientoService.putSolicitudMedicacion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            createMode
              ? "Solicitud creada correctamente"
              : "Solicitud actualizada correctamente",
            "success",
            "Comando Exitoso"
          )
        );

        if (result.ok) {
          if (createMode) {
            dispatch(updateSolicitud("idSolicitud", body.idSolicitud));
            dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
            dispatch(updateSolicitud("idSolicitudEmp", body.idSolicitudEmp));
            dispatch(updateSolicitud("medicamentos", []));
          } else {
            dispatch(updateSolicitud("medicamentos", body.medicamentos));
            dispatch({
              type: types.empadronamientoGetMedicamentosSuccess,
              payload: body.medicamentos,
            });
          }
        }


        if (setShowForm) dispatch(setShowForm(false));
        if (setActiveStep) dispatch(setActiveStep(step));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar receta"
          : "Error al crear la receta",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postMedicamentos = (
  medicamentos,
  avanzarPantalla = null
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.postMedicamentos(medicamentos);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updateSolicitud("medicamentos", body));
        dispatch({
          type: types.empadronamientoGetMedicamentosSuccess,
          payload: body,
        });
        if (avanzarPantalla) avanzarPantalla();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar los medicamentos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postMedicamentosMedicacion = (
  medicamentos,
  avanzarPantalla = null,
  cerrarAlert = null
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.postMedicamentosMedicacion(medicamentos);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updateSolicitud("medicamentos", body));
        dispatch({
          type: types.empadronamientoGetMedicamentosSuccess,
          payload: body,
        });
        avanzarPantalla && avanzarPantalla();
        cerrarAlert && cerrarAlert(false);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar los medicamentos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const confirmarSolicitud = (idSolicitud, imprimir, autorizarSolicitud, setRedirect, esAuditor,
  esAuditorEsp, esAuditorDisca, setOpenModalGestionar = null, idTipoEmpadronamiento = null) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;

      const result = await EmpadronamientoService.putSolicitudFinalizada({ idSolicitud, esAuditor, esAuditorEsp, esAuditorDisca });
      const body = await result.json();
      if (!result.ok) {
        throw body;
      } else {
        dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
        if (autorizarSolicitud) {
          if (imprimir) {
            //dispatch(imprimirPDFSolicitud(idSolicitud, setRedirect));
          } else {
            //dispatch(enviarPDFSolicitud(idSolicitud, setRedirect));
          }
          dispatch(startAlerta(`Solicitud confirmada exitosamente`, 'success', 'Comando Exitoso'));
          setRedirect && setRedirect(true);
          setOpenModalGestionar && setOpenModalGestionar(false);
          dispatch(finishSpinner());
        } else {
          dispatch(finishSpinner());
          dispatch(startAlerta(`Solicitud confirmada exitosamente`, 'success', 'Comando Exitoso'));
          setRedirect && setRedirect(true);
          setOpenModalGestionar && setOpenModalGestionar(false);

          if (setOpenModalGestionar) {
            dispatch(getContadoresEmpadronamientosBandeja(null,
              idTipoEmpadronamiento,
              null,
              null,
              null,
              EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION,
              validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
              ),
              validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
              ),
              validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
              )));
            dispatch(getSolicitudesBandeja(null,
              idTipoEmpadronamiento,
              null,
              null,
              null,
              EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION,
              validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
              ),
              validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
              ),
              validarSoloUnPermiso(
                permisosUser,
                EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
              ),
              false));
          }
        }
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const confirmarSolicitudMedicacion = (idSolicitud, idEstadoSolicitud, setRedirect, setOpenModalGestionar = null) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      const result = await EmpadronamientoService.putSolicitudMedicacionFinalizada({ idSolicitud, idEstadoSolicitud });
      const body = await result.json();
      if (!result.ok) {
        throw body;
      } else {
        dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
        dispatch(finishSpinner());
        dispatch(startAlerta(`Solicitud confirmada exitosamente`, 'success', 'Comando Exitoso'));
        setRedirect && setRedirect(true);
        setOpenModalGestionar && setOpenModalGestionar(false);

        if (setOpenModalGestionar) {
          dispatch(getContadoresMedicacionBandeja(null,
            null,
            solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
            null,
            null,
            EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION,
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            )));
          dispatch(getMedicacionBandeja(null,
            null,
            solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
            null,
            null,
            EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION,
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            )));
        }
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const seleccionarDisponibilidadScienza = (
  IdItemMed,
  IdItemEmp,
  CodigoSap,
  Disponibilidad,
  PrecioFinal,
  Descuento,
  Pvp,
  IdAlfabeta,
  Troquel,
  Forma,
  Laboratorio,
  Nombre,
  IdMonodroga
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.setisponibilidadScienza({
        IdItemMed,
        IdItemEmp,
        CodigoSap,
        Disponibilidad,
        PrecioFinal,
        Descuento,
        Pvp,
        IdAlfabeta,
        Troquel,
        Forma,
        Laboratorio,
        Nombre,
        IdMonodroga
      });
      const body = await result.json();
      if (!result.ok) {
        throw body;
      } else {
        //Tengo que actualizar el state
        dispatch(
          setearValorEnMedicamentoPorIdItem(
            IdItemMed !== null ? IdItemMed : IdItemEmp,
            "troquelSeleccionadoSC",
            parseInt(Troquel)
          )
        );
        dispatch(
          setearValorEnMedicamentoPorIdItem(
            IdItemMed !== null ? IdItemMed : IdItemEmp,
            "idDisponibilidadSC",
            1
          )
        );


        dispatch(finishSpinner());
        dispatch(startAlerta(`Disponibilidad seleccionada exitosamente`, 'success', 'Comando Exitoso'));
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

/*
export const confirmarSolicitudMedicacion = (idSolicitud, imprimir, autorizarSolicitud, setRedirect, esAuditor,
  esAuditorEsp, esAuditorDisca) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.putSolicitudMedicacionFinalizada({ idSolicitud, esAuditor, esAuditorEsp, esAuditorDisca });
      const body = await result.json();
      if (!result.ok) {
        throw body;
      } else {
        dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
        if (autorizarSolicitud) {
          if (imprimir) {
            dispatch(imprimirPDFSolicitudMedicacion(idSolicitud, setRedirect));
          } else {
            dispatch(enviarPDFSolicitudMedicacion(idSolicitud, setRedirect));
          }
        } else {
          dispatch(finishSpinner());
          dispatch(startAlerta(`Solicitud confirmada exitosamente`, 'success', 'Comando Exitoso'));
          setRedirect && setRedirect(true);
        }
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
*/


export const anularSolicitud = (idSolicitud, idEstadoSolicitud, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      dispatch(startSpinner());
      const response = await EmpadronamientoService.putAnularSolicitud({ idSolicitud });
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Solicitud anulada correctamente`, 'success', 'Comando Exitoso'));

        setOpenModalGestionar && setOpenModalGestionar(false);
        //dispatch(enviarRechazoSolicitud(idSolicitud, setOpenModalGestionar));

        dispatch(getContadoresEmpadronamientosBandeja(null,
          solicitudSeleccionada?.idTipoEmpadronamiento,
          null,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
        dispatch(getSolicitudesBandeja(null,
          solicitudSeleccionada?.idTipoEmpadronamiento,
          null,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          ),
          false));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el rechazo",
        "Ha ocurrido un error."
      );
    }
  };
};

export const rechazarSolicitud = (idSolicitud, idEstadoSolicitud, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      dispatch(startSpinner());
      const response = await EmpadronamientoService.putRechazarSolicitud({ idSolicitud });
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Solicitud rechazada correctamente`, 'success', 'Comando Exitoso'));

        setOpenModalGestionar && setOpenModalGestionar(false);
        //dispatch(enviarRechazoSolicitud(idSolicitud, setOpenModalGestionar));

        dispatch(getContadoresEmpadronamientosBandeja(null,
          solicitudSeleccionada?.idTipoEmpadronamiento,
          null,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
        dispatch(getSolicitudesBandeja(null,
          solicitudSeleccionada?.idTipoEmpadronamiento,
          null,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          ),
          false));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el rechazo",
        "Ha ocurrido un error."
      );
    }
  };
};

/*
export const rechazarSolicitud = (idSolicitud, motivoRechazo, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.putSolicitudRechazada({ idSolicitud, motivoRechazo });
      const body = await result.json();
      if (!result.ok) {
        dispatch(finishSpinner());
        throw body;
      } else {
        dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
        dispatch(startAlerta(`Solicitud rechazada exitosamente`, 'success', 'Comando Exitoso'));
        dispatch(enviarRechazoSolicitud(idSolicitud, setOpenModalGestionar));
        dispatch(finishSpinner());
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
*/

/*
export const rechazarMedicacion = (idSolicitud, motivoRechazo, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.putMedicacionRechazada({ idSolicitud, motivoRechazo });
      const body = await result.json();
      if (!result.ok) {
        dispatch(finishSpinner());
        throw body;
      } else {
        dispatch(updateSolicitud("idEstadoSolicitud", body.idEstadoSolicitud));
        dispatch(startAlerta(`Solicitud rechazada exitosamente`, 'success', 'Comando Exitoso'));
        dispatch(enviarRechazoMedicacion(idSolicitud, setOpenModalGestionar));
        dispatch(finishSpinner());
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de la Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
*/

export const enviarRechazoMedicacion = (idSolicitud, setOpenModalGestionar = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await EmpadronamientoService.enviarRechazoMedicacion(idSolicitud);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        setOpenModalGestionar && setOpenModalGestionar(false);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del Rechazo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const enviarRechazoSolicitud = (idSolicitud, setOpenModalGestionar = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await EmpadronamientoService.enviarRechazoSolicitud(idSolicitud);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        setOpenModalGestionar && setOpenModalGestionar(false);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del Rechazo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const enviarPDFSolicitudMedicacion = (idSolicitud, setRedirect = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await EmpadronamientoService.enviarSolicitudMedicacion(idSolicitud);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        setRedirect && setRedirect(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const enviarPDFSolicitud = (idSolicitud, setRedirect = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await EmpadronamientoService.enviarSolicitud(idSolicitud);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        setRedirect && setRedirect(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const imprimirPDFSolicitudMedicacion = (idSolicitud, setRedirect = null) => {
  return async (dispatch) => {
    try {
      const response = await EmpadronamientoService.imprimirSolicitudMedicacion(idSolicitud);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
          setRedirect && setRedirect(true);
        } else {
          throw body;
        }
      } else {
        const error = await response.json();
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Ocurrio un error en la generación del PDF",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la generación del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const imprimirPDFSolicitud = (idSolicitud, setRedirect = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await EmpadronamientoService.imprimirSolicitud(idSolicitud);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
          setRedirect && setRedirect(true);
        } else {
          throw body;
        }
      } else {
        const error = await response.json();
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          "Ocurrio un error en la generación del PDF",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la generación del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const repetirSolicitudEmp = (
  data,
  postRetomarSolicitud
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.postRepetirSolicitud(data)
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Solicitud de Empadronamiento creada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        postRetomarSolicitud(body);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al repetir Empadronamiento"
          : "Error al repetir Empadronamiento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//DOCUMENTACION SOLICITUD
export const getDocumentacionSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getDocumentacionSolicitud(idSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionSolicitud = (idSolicitud, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.deleteDocumentacionSolicitud(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposDocumentacion = (idTipoEmpadronamiento = null, idPatologia = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getTiposDocumentacion(idTipoEmpadronamiento, idPatologia);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoSolicitudEmpHandler = (idSolicitud, idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_EMPADRONAMIENTO) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoSolicitudEmp(formData, idSolicitud, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_EMPADRONAMIENTO
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoSolicitudEmp = (formData, idSolicitud, idTipoDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      debugger
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionEmpadronamientoSolicitud/${idSolicitud}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const resetBuscadorPrograma = () => {
  return {
    type: types.empadronamientoResetBuscadorTiposEmpadronamiento,
  };
};


export const getProgramaTexto = (texto) => async (dispatch) => {
  try {
    const response = await EmpadronamientoService.getBuscardorTipoEmpadronamientoTexto(texto);

    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.empadronamientoGetBuscadorTiposEmpadronamientoSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.empadronamientoGetBuscadorTiposEmpadronamientoError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los programas",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const finalizarSolicitud = (idSolicitud, fechaFin, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      const response = await EmpadronamientoService.finalizarSolicitud({ idSolicitud, fechaFin });
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Solicitud finalizada correctamente`, 'success', 'Comando Exitoso'));

        dispatch({
          type: types.empadronamientoAnularSolicitudSuccess,
          payload: idSolicitud,
        });

        setOpenModalGestionar && setOpenModalGestionar(false);

        if (setOpenModalGestionar) {
          dispatch(getContadoresEmpadronamientosBandeja(solicitudSeleccionada?.idAfiliado,
            solicitudSeleccionada?.idTipoEmpadronamiento,
            null,
            null,
            null,
            EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA,
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            )));
          dispatch(getSolicitudesBandeja(solicitudSeleccionada?.idAfiliado,
            solicitudSeleccionada?.idTipoEmpadronamiento,
            null,
            null,
            null,
            EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA,
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            ),
            false));
        }

      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la finalizacion",
        "Ha ocurrido un error."
      );
    }
  };
};


export const generateExcelConsultaEmpadronamiento = (idAfiliado,
  idTipoEmpadronamiento,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  esAuditor) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const response = await EmpadronamientoService.getExcelConsultaEmpadronamientos(idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        esAuditor)
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
        let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = "ConsultaEmpadronamientos_" + new Date().toLocaleDateString().replace("/", "_").replace("/", "_") + ".xlsx";
        a.click();
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el excel",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };


export const generateExcelConsultaMedicacion = (idAfiliado,
  idTipoEmpadronamiento,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  esAuditor) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const response = await EmpadronamientoService.getExcelConsultaMedicacion(idAfiliado,
        idTipoEmpadronamiento,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        esAuditor)
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
        let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = "ConsultaMedicacion_" + new Date().toLocaleDateString().replace("/", "_").replace("/", "_") + ".xlsx";
        a.click();
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el excel",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }


export const addMedicamento = (medicamento) => {
  return { type: types.empadronamientoAddMedicamento, payload: medicamento };
};
export const replaceMedicamentosPorSeleccionados = (medicamentos) => {
  return { type: types.empadronamientoReplaceMedicamentosPorSeleccionados, payload: medicamentos };
};

export const repetirMedicacion = (
  data,
  postRetomarMedicacion
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.postRepetirMedicacion(data)
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Solicitud de Medicacion creada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        postRetomarMedicacion(body);
        //dispatch(updateSolicitud("idRecetaDigital", body.idRecetaDigital));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.empadronamientoGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al repetir Medicacion"
          : "Error al repetir Medicacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const anularMedicacion = (idSolicitud, idEstadoSolicitud, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      dispatch(startSpinner());
      const result = await EmpadronamientoService.putAnularMedicacion({ idSolicitud });
      const body = await result.json();
      if (result.ok) {
        dispatch(startAlerta(`Solicitud anulada exitosamente`, 'success', 'Comando Exitoso'));
        //dispatch(enviarRechazoMedicacion(idSolicitud, setOpenModalGestionar));
        setOpenModalGestionar && setOpenModalGestionar(false);

        dispatch(getContadoresMedicacionBandeja(null,
          null,
          solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));

        dispatch(getMedicacionBandeja(null,
          null,
          solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error al rechazar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const rechazarMedicacion = (idSolicitud, idEstadoSolicitud, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      dispatch(startSpinner());
      const result = await EmpadronamientoService.putRechazarMedicacion({ idSolicitud });
      const body = await result.json();
      if (result.ok) {
        dispatch(startAlerta(`Solicitud rechazada exitosamente`, 'success', 'Comando Exitoso'));
        //dispatch(enviarRechazoMedicacion(idSolicitud, setOpenModalGestionar));
        setOpenModalGestionar && setOpenModalGestionar(false);

        dispatch(getContadoresMedicacionBandeja(null,
          null,
          solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));

        dispatch(getMedicacionBandeja(null,
          null,
          solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error al rechazar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const devolverMedicacion = (idSolicitud, idEstadoSolicitud, setOpenModalGestionar = null, filtros = null) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      dispatch(startSpinner());
      const result = await EmpadronamientoService.devolverMedicacion({ idSolicitud });
      const body = await result.json();
      if (result.ok) {
        dispatch(startAlerta(`Solicitud devuelta exitosamente`, 'success', 'Comando Exitoso'));
        setOpenModalGestionar && setOpenModalGestionar(false);

        dispatch(getContadoresMedicacionBandeja(null,
          null,
          solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));

        dispatch(getMedicacionBandeja(null,
          null,
          solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del Rechazo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTrackingSolicitudEmp = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getTrackingSolicitudEmp(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetTrackingSolicitudSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetTrackingSolicitudError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTrackingSolicitudMed = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getTrackingSolicitudMed(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetTrackingSolicitudMedicacionSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetTrackingSolicitudMedicacionError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//DOCUMENTACION MEDICACION

export const getDocumentacionSolicitudMedicacion = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getDocumentacionSolicitudMedicacion(idSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetDocumentacionMedicacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoSolicitudMedicacion = (file, idSolicitud, idTipoDocumento) => {
  return async (dispatch) => {
    debugger
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const formData = new FormData();
      formData.append('files', file);
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionSolicitudMedicacionEmpadronamiento/${idSolicitud}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionSolicitudMedicacion(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const deleteDocumentacionSolicitudMedicacion = (idSolicitud, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.deleteDocumentacionSolicitudMedicacion(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionSolicitudMedicacion(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//Scienza disponibilidad
export const getDisponibilidadMedicamentosScienza = (idMonodroga, abrirModal) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getDisponibilidadScienza(idMonodroga);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetDisponibilidadScienzaSucces,
          payload: body,
        });
        abrirModal && abrirModal(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
        dispatch({
          type: types.empadronamientoGetDisponibilidadScienzaError
        });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la disponibilidad de los medicamentos.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPatologiasEmp = (idTipoEmpadronamiento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      debugger
      const result = await EmpadronamientoService.getPatologias(idTipoEmpadronamiento);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientosGetPatologias,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las patologias",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const devolverSolicitud = (idSolicitud, setOpenModalGestionar, idEstadoSolicitud) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      dispatch(startSpinner());
      const data = {
        IdSolicitudEmpadronamiento: idSolicitud
      }
      const response = await EmpadronamientoService.devolverSolicitud(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Solicitud devuelta correctamente`, 'success', 'Comando Exitoso'));

        setOpenModalGestionar && setOpenModalGestionar(false);
        dispatch(getContadoresEmpadronamientosBandeja(null,
          solicitudSeleccionada?.idTipoEmpadronamiento,
          null,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          )));
        dispatch(getSolicitudesBandeja(null,
          solicitudSeleccionada?.idTipoEmpadronamiento,
          null,
          null,
          null,
          idEstadoSolicitud,
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
          ),
          validarSoloUnPermiso(
            permisosUser,
            EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
          ),
          false));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la devolucion",
        "Ha ocurrido un error."
      );
    }
  };
};


export const autorizarSolicitud = (idSolicitud, idEstadoSolicitud, setOpenModalGestionar) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const data = {
        IdSolicitudEmp: idSolicitud
      }
      const state = getState();
      const { permisos: permisosUser } = state.auth;
      const { solicitudSeleccionada = {} } = state.empadronamiento;

      const response = await EmpadronamientoService.AutorizarSolicitud(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Solicitud autorizada correctamente`, 'success', 'Comando Exitoso'));

        setOpenModalGestionar && setOpenModalGestionar(false);

        if (setOpenModalGestionar) {
          dispatch(getContadoresEmpadronamientosBandeja(null,
            solicitudSeleccionada?.idTipoEmpadronamiento,
            null,
            null,
            null,
            idEstadoSolicitud,
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            )));
          dispatch(getSolicitudesBandeja(null,
            solicitudSeleccionada?.idTipoEmpadronamiento,
            null,
            null,
            null,
            idEstadoSolicitud,
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ),
            validarSoloUnPermiso(
              permisosUser,
              EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_DISCA
            ),
            false));
        }

      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la devolucion",
        "Ha ocurrido un error."
      );
    }
  };
};

export const agregarAlerta = (idAlerta, idSolicitud, fechaAlerta, mensaje, closeModal) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const data = {
        IdAlerta: idAlerta,
        IdSolicitudEmp: idSolicitud,
        fechaAlerta: fechaAlerta,
        Mensaje: mensaje
      }
      let response;
      if (idAlerta) {
        response = await EmpadronamientoService.ModificarAlertaEmpadronamiento(data);

      } else {
        response = await EmpadronamientoService.AgregarAlertaEmpadronamiento(data);
      }
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta(`Alerta Cargada Correctamente`, 'success', 'Comando Exitoso'));
        dispatch(getAlertasEmpadronamiento(idSolicitud));
        closeModal && closeModal(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en la carga de la alerta.",
        "Ha ocurrido un error."
      );
    }
  };
};

export const getAlertasEmpadronamiento = (IdSolicitudEmp) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.GetAlertaPorEmp(IdSolicitudEmp);
      let body = {};
      if (result.status !== 204) {
        body = await result.json();
      }
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoAlertasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoAlertasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las alertas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTiposDocumentacionMedicacion = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.getTiposDocumentacionMedicacion();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.empadronamientoGetTiposDocumentacionMedicacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación de la medicacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
//NOTAS SOLICITUD EMPADRONAMIENTO
export const getNotasPorSolicitudEmpadronamiento = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getNotas(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const postNotasEmpadronamiento = (data, idSolicitud, method, closeModalHandler,
  idEstadoSolicitud, idTipoNota, setOpenModalGestionar, fechaFin = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.postNotas(data, method);
      const body = await result.json();
      if (result.ok) {
        if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.DEVOLUCION) {
          dispatch(devolverSolicitud(
            idSolicitud,
            setOpenModalGestionar,
            idEstadoSolicitud))
        } else if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.RECHAZO) {
          dispatch(rechazarSolicitud(
            idSolicitud,
            idEstadoSolicitud,
            setOpenModalGestionar
          ))
        } else if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.ANULACION) {
          dispatch(anularSolicitud(
            idSolicitud,
            idEstadoSolicitud,
            setOpenModalGestionar
          ))
        } else if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.AUTORIZACION) {
          dispatch(autorizarSolicitud(
            idSolicitud,
            idEstadoSolicitud,
            setOpenModalGestionar
          ))
        } else if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.FINALIZACION) {
          dispatch(finalizarSolicitud(
            idSolicitud,
            fechaFin,
            setOpenModalGestionar
          ))
        } else {
          dispatch(
            startAlerta(
              "Datos Guardados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(getNotasPorSolicitudEmpadronamiento(idSolicitud));
        }
      } else {
        throw body;
      }
      if (closeModalHandler)
        closeModalHandler();

      setOpenModalGestionar === undefined && dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las notas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const actualizarFechaFin = (fechaFin, idSolicitud, closeModalHandler) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.putFechaFin({ fechaFin, idSolicitud }, "PUT");
      const body = await result.json();
      if (result.ok) {
        dispatch(updateSolicitud("fechaFin", fechaFin));

        dispatch(
          startAlerta(
            "Fecha Fin Actualizada Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }

      if (closeModalHandler)
        closeModalHandler();

      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error actualizar la fecha",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const deleteNotaEmpadronamiento = (idNota, idSolicitud, closeModalDelete) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.deleteNota({ idNota });
      const body = await result.json();
      if (result.ok) {
        dispatch(getNotasPorSolicitudEmpadronamiento(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
      if (closeModalDelete) closeModalDelete();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//NOTAS SOLICITUD MEDICACION
export const getNotasPorSolicitudMedicacion = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getNotasMedicacion(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoMedicacionGetNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoMedicacionGetNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};


export const postNotasMedicacion = (data, idSolicitud, method, closeModalHandler,
  idEstadoSolicitud, idTipoNota, setOpenModalGestionar) => {
  return async (dispatch,) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.postNotasMedicacion(data, method);
      const body = await result.json();
      if (result.ok) {
        if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.DEVOLUCION) {
          dispatch(devolverMedicacion(
            idSolicitud,
            idEstadoSolicitud,
            setOpenModalGestionar,
            null))
        } else if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.RECHAZO) {
          dispatch(rechazarMedicacion(
            idSolicitud,
            idEstadoSolicitud,
            setOpenModalGestionar
          ))
        } else if (idTipoNota === EMPADRONAMIENTO_TIPOS_NOTAS.ANULACION) {
          dispatch(anularMedicacion(
            idSolicitud,
            idEstadoSolicitud,
            setOpenModalGestionar
          ))
        } else {
          dispatch(
            startAlerta(
              "Datos Guardados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(getNotasPorSolicitudMedicacion(idSolicitud));
        }
      } else {
        throw body;
      }
      if (closeModalHandler)
        closeModalHandler();

      setOpenModalGestionar === undefined && dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las notas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteNotaMedicacion = (idNota, idSolicitud, closeModalDelete) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.deleteNotaMedicacion({ idNota });
      const body = await result.json();
      if (result.ok) {
        dispatch(getNotasPorSolicitudMedicacion(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
      if (closeModalDelete) closeModalDelete();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getConveniosScienza = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getConveniosScienza();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetConveniosScienzaSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetConveniosScienzaError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los convenios.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//TIPOS NOTAS 
export const getTiposNotasEmpadronamiento = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getTiposNotasEmpadronamiento();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetTiposNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetTiposNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los tipos de notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};
export const getTiposNotasTodasEmpadronamiento = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getTiposNotasEmpadronamientoTodas();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetTiposNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetTiposNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los tipos de notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTrackingEnviosScienza = (idSolicitudEmp = null, idSolicitudMed = null) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getTrackingScienza(idSolicitudEmp, idSolicitudMed);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.empadronamientoGetTrackingScienzaSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetTrackingScienzaError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking de scienza.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTrackingEnviosNosConecta = (idSolicitudEmp = null, idSolicitudMed = null) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await EmpadronamientoService.getTrackingNosConecta(idSolicitudEmp, idSolicitudMed);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      
      dispatch({
        type: types.empadronamientoGetTrackingNosConectaSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.empadronamientoGetTrackingNosConectaError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking de NosConecta.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};



export const sendMailAlerta = (idAfiliado) => {
  return async (dispatch,) => {
    try {
      dispatch(startSpinner());
      const result = await EmpadronamientoService.SendMailAlerta(idAfiliado);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Mail enviado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar el mail",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};